import React from 'react';
import { getLocale, isTodayFormat } from '../../helpers/dates';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { format, parseISO } from 'date-fns';
import CheckIcon from '../icons/CheckIcon';
import Money from '../Common/Money/Money';
import styles from './PaymentLinkItem.module.css';
import { SuccessIcon } from '../icons/successIcon';

const PaymentLinkItem = ({ index, activity, handleClick, date, amount }) => {
  const app = useSelector((state) => state.app);
  const locale = getLocale(app.language);
  const { t } = useTranslation();

  const statusTexts = {
    WAITING_DEPOSIT: t('paymentLinkStatus.pending').toUpperCase(),
    REJECTED: t('paymentLinkStatus.rejected').toUpperCase(),
    CANCELLED: t('paymentLinkStatus.cancelled').toUpperCase(),
    EXPIRED: t('paymentLinkStatus.expired').toUpperCase(),
  };

  const getRightText = (activity) => {
    if (activity.status === 'CLOSED' || activity.status === 'CONFIRMED') {
      return (
        <div className='text-right'>
          <SuccessIcon
            size={12}
            checkColor='#fff'
            circleColor='#00bb00'
            styles={{ marginTop: '-2px', marginRight: '.25rem' }}
          />
          <Money value={activity.amount} lowDecimals decimal={false} />
        </div>
      );
    } else {
      const statusClass = styles[activity.status.toLowerCase().replace(/\s+/g, '')] || '';
      let statusColorClass = '';

      if (activity.status === 'CONFIRMED') {
        statusColorClass = styles.greenCircle;
      } else if (activity.status === 'CANCELLED' || activity.status === 'REJECTED') {
        statusColorClass = styles.redCircle;
      }

      return (
        <div className={`${statusClass} font-extra-small ${styles.activityItemStatus}`}>
          {statusColorClass && (
            <span className={`${styles.statusCircle} ${statusColorClass}`}></span>
          )}
          <span style={{ fontSize: '.7rem' }}>{statusTexts[activity.status]}</span>
        </div>
      );
    }
  };

  return (
    <div
      key={index}
      className={`activity-item-container ${
        activity.status === 'PENDING' ? 'border-none p-0' : ''
      }`}
      style={{ color: activity.status === 'CANCELLED' ? '#7e7e7e' : '' }}
    >
      <div
        className={`row font-small ${styles.activityItem} 
         ${activity.status === 'PENDING' ? styles.isCallcenter : ''}`}
        key={index}
        onClick={handleClick}
      >
        <div className='col-auto bold text-center pr-0' style={{ width: '70px' }}>
          <div>{isTodayFormat(date, locale, t, activity.isToday)}</div>
          <div>{format(parseISO(date), 'HH:mm', { locale })}</div>
        </div>
        <div className='col text-truncate pl-2'>
          <>
            <div className='bold text-truncate'>{activity.restaurantName || activity.showName}</div>
            <div className={`${styles.activityItemInfo} text-secondary text-truncate`}>
              {activity.customerName}
            </div>
          </>
        </div>
        <div className='col-auto my-auto'>{getRightText(activity, amount)}</div>
      </div>
    </div>
  );
};

export default PaymentLinkItem;
